<script setup>

const props = defineProps({
  modelValue: Boolean,
  title: String,
  disabled: {
      type: Boolean,
      default: false
  },
  hasError: Boolean | undefined,
    titleClass: String | undefined
});
const emit = defineEmits(['update:model-value']);
</script>

<template>
    <div class="flex items-center">
        <span :class="titleClass ? titleClass: 'font-sans font-medium text-black dark:text-slate-200 mr-2'">{{ title }}</span>
    <label class="relative inline-flex items-center cursor-pointer">
      <input :disabled="disabled" :checked="modelValue" class="sr-only peer" type="checkbox"
             @click="emit('update:model-value', !modelValue)">
      <div
          class="w-11 h-6 bg-gray-200 dark:bg-slate-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white dark:peer-checked:after:border-dark-blue after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white dark:after:bg-dark-blue after:border-gray-300 dark:after:border-dark-blue after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
      </div>
      <!--    <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Toggle me</span>-->
    </label>
  </div>
</template>

<style scoped>

</style>
